import { useMutation } from '@tanstack/react-query';
import { useBoundStore } from '@Store/index.ts';
import {
  identifyTrackingServiceUser,
  setPeopleProperty,
} from '@Services/analytics/tracking.service.ts';
import { LiliPlanType } from '@Pages/happyFlowPages/planSelection/types.ts';
import { identifyLogRocketUser } from '@Services/analytics/logrocket.service.ts';
import {
  getFlowId,
  identifyGA4User,
  setGA4UserProperties,
} from '@Services/analytics/analytics.service.ts';
import { useWelcomeAnalytics } from '@Pages/passwordless/welcome/WelcomeAnalytics.tsx';
import { createLead } from '@Services/init/welcome.api';

export const useCreatePartnerLead = () => {
  const customerData = useBoundStore((state) => state.customer);
  const { isFromLiliApp } = useBoundStore((state) => state.onboardingSlice);
  const setCustomerData = useBoundStore((state) => state.setCustomerData);
  const { reportStartOnboarding } = useWelcomeAnalytics();

  return useMutation({
    mutationFn: createLead,
    onSuccess: (data) => {
      identifyTrackingServiceUser(data.externalId);
      identifyGA4User(data.externalId);
      reportStartOnboarding();
      const analyticsProps = {
        canSelectPlan: true,
        isFromLiliApp,
        defaultPlanSelected: LiliPlanType.SMART, // @TODO: check with Nir.
        flowId: getFlowId(),
      };
      setPeopleProperty(analyticsProps);
      const updatedCustomerData = { ...customerData, ...data };
      setCustomerData(updatedCustomerData);
      identifyLogRocketUser(data.externalId);
      setGA4UserProperties();
    },
  });
};
